import styled from 'styled-components';

import { Divider, GridLegacy as Grid } from '@mui/material';

export const ShowRelevantFieldsContainer = styled.div`
  display: flex;
  padding: 4px 12px;
  align-items: center;
  gap: 4px;
  justify-content: space-between;
  border-radius: 8px;
  background: ${({ theme }) => theme.toast.warning.background};
  margin-bottom: 16px;

  p {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 14px;
    margin: 0;
  }
`;

// `$flush` is audits-only: with no outer card, the Details sections start where the Answers tab's do.
export const BackgroundInformationSections = styled.div<{ $flush?: boolean }>`
  position: relative;
  overflow-y: scroll;
  margin: ${({ $flush }) => ($flush ? 0 : '15px 20px')};
  & {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledRowWrapper = styled.div`
  width: 100%;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
`;

export const StyledDivider = styled(Divider)`
  margin-top: 7px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex: 1;
  background: ${({ theme }) => theme.palette.common.white};
  padding: 10px 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const SectionHeader = styled(Grid)`
  display: flex;
  justify-content: center;
  padding: 0px;
  background: ${({ theme }) => theme.palette.primary.light};
  border-radius: 5px;
  p {
    font-weight: 400;
    font-size: 20px;
    line-height: 160%;
    color: ${({ theme }) => theme.palette.primary.main};
    margin: 8px;
  }
`;

// `$white` is audits-only: every other module keeps the grey band.
export const SectionContainerHeader = styled.div<{ $expanded: boolean; $white?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${({ $expanded, theme }) => ($expanded ? `1px solid ${theme.palette.grey[300]}` : null)};
  padding: 0 20px;
  background: ${({ theme, $white }) => ($white ? theme.palette.common.white : theme.palette.grey[100])};
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin: 11px 12px;
`;

// `$white` is audits-only: the read rows are inset by the Collapse, and edit mode has no white of its own,
// so on the page ground the card would show grey strips. Painting the section closes both.
export const Section = styled.div<{ $white?: boolean }>`
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: 8px;
  margin-bottom: 10px;
  background: ${({ $white, theme }) => ($white ? theme.palette.common.white : 'transparent')};
  overflow: ${({ $white }) => ($white ? 'hidden' : 'visible')};
`;

export const RequiredAsterisk = styled.span`
  color: #d32f2f;
  margin-left: 2px;
`;
